import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SearchLiteraturesService } from './core/search-literatures.service';
import { Alert, ALERT_TYPE } from '../../../../components/alert/alert.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'search-literatures',
  templateUrl: './search-literatures.component.html',
  styleUrl: './search-literatures.component.scss',
  standalone: false,
})
export class SearchLiteraturesComponent implements OnInit, OnDestroy {
  searchRequest$ = this.searchLiteraturesService.get();
  subscription = new Subscription();
  errorMessage: Alert = {
    isActive: true,
    content: '',
    type: ALERT_TYPE.DANGER,
    hasCloseButton: false,
  };

  currentTerm = '';

  constructor(
    private searchLiteraturesService: SearchLiteraturesService,
    private activeRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.getCurrentTerm();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getCurrentTerm() {
    this.subscription.add(
      this.activeRoute.params.subscribe(params => {
        this.currentTerm = params['query'];
        this.checkLiteratures();
      }),
    );
  }

  checkLiteratures() {
    this.subscription.add(
      this.searchRequest$.subscribe(searchRequest => {
        searchRequest.isPristine && this.searchLiteraturesService.fetch(this.currentTerm, 0);

        if (searchRequest.hasError && searchRequest.message) {
          this.errorMessage.content = searchRequest.message;
        }

        this.cdr.detectChanges();
      }),
    );
  }

  pageChange(page: number): void {
    this.searchLiteraturesService.fetch(this.currentTerm, page);
  }
}
